import { createInitialState, normalizeState } from "./domain";
import type { AppState } from "./types";

export const STORAGE_KEY = "codepawl.roam.state.v2";
export const LEGACY_STORAGE_KEY = "codepawl.roam.state.v1";

/** Read the v2 state first; a v1 state is migrated and copied without deleting the legacy record. */
export function loadState(): AppState {
  try {
    const current = window.localStorage.getItem(STORAGE_KEY);
    if (current) return normalizeState(JSON.parse(current));

    const legacy = window.localStorage.getItem(LEGACY_STORAGE_KEY);
    if (!legacy) return createInitialState();
    const migrated = normalizeState(JSON.parse(legacy));
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(migrated));
    return migrated;
  } catch {
    return createInitialState();
  }
}

export function saveState(state: AppState): void {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
}

export function clearState(): void {
  window.localStorage.removeItem(STORAGE_KEY);
  window.localStorage.removeItem(LEGACY_STORAGE_KEY);
}
